module.exports = __webpack_public_path__ + "static/media/img1.69f2f4e0.png";